// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rc-tooltip{max-width:50%}@media (max-width: 767.98px){.rc-tooltip{max-width:80%}}\n", ""]);
// Exports
module.exports = exports;
